/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { RoutingService } from 'src/app/service/routing.service';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/service/auth.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { UserInfoService } from 'src/app/shared/services/user-info.service';
import { ConfigService } from 'src/app/service/config.service';
import { AlertsSetupComponent } from 'src/app/project/settings/alerts-setup/alerts-setup.component';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { FilterListService } from '../menu-filters/service/filter-list.service';

@Component({
  selector: 'app-menu-aside',
  templateUrl: './menu-aside.component.html',
  styleUrls: ['./menu-aside.component.scss'],
})
export class MenuAsideComponent implements OnInit {
  asidetxt: boolean;
  params: any;
  user: any = {
    id: '',
    email: '',
    account: 'customer',
    expire: '',
    roles: [],
    groups: [],
  };
  project: any;
  setup: any;
  // subscription: string;
  account: boolean;
  eventsList: any;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public routing: RoutingService,
    public location: Location,
    public auth: AuthService,
    public featureFlagsService: FeatureFlagsService,
    public userInfo: UserInfoService,
    public config: ConfigService,
    public snackBar: MatSnackBar,
    private filterListService: FilterListService,
  ) {
    this.project = this.config.appConfig.routing.project;
    this.setup = this.config.appConfig.setup;
    if (this.config.appConfig.setup.useStorage) {
      this.asidetxt = localStorage.getItem('aside') === 'true';
    }
    this.user = this.auth.authToken();

    // if (this.user) { this.subscription = this.user.subscription; }
    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });
  }

  ngOnInit() {
    this.filterListService.getEventList().subscribe((eventList) => {
      this.eventsList = JSON.parse(JSON.stringify(eventList));
    });
  }

  logOut() {
    this.auth.authLogout();
  }

  myAsidetxt() {
    this.asidetxt = !this.asidetxt;
    if (this.config.appConfig.setup.useStorage) {
      localStorage.setItem('aside', this.asidetxt.toString());
    }
  }

  /**
   * open mat-dialog for alerts
   */
  openAlerts() {
    if (this.eventsList) {
      this.dialog.open(AlertsSetupComponent, {
        autoFocus: false,
      });
    }
  }
}
